<template>
    <div class="form-container">
         <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Selected Templates Selected for Move/Copy</strong>
                    </div>
                    <div class="form-container">
                        <b-row>
                            <b-col sm="2">
                                <div class="mb-3">
                                    <strong>Action</strong>
                                </div>
                            </b-col>
                            <b-col sm="4">
                                <div class="mb-3">
                                    <strong>Template</strong>
                                </div>
                            </b-col>
                            <b-col sm="4">
                                <div class="mb-3">
                                    <strong>Trade Customer</strong>
                                </div>
                            </b-col>
                            <b-col sm="2">
                                <div class="mb-3">
                                    <strong>Plate Size</strong>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-for="template in templateItems" v-bind:key="template.id" class="output-row">
                            <b-col sm="2">
                                <b-input-group>
                                    <b-form-input
                                    v-model="template.action"
                                    type="text"
                                    class="form-control"
                                    :id="'template-' + template.id + '-' + template.action"
                                    readonly
                                    ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col sm="4">
                                <b-input-group>
                                    <b-form-input
                                    v-model="template.template_name"
                                    type="text"
                                    class="form-control"
                                    :id="'template-' + template.id + '-' + template.template_name"
                                    readonly
                                    ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col sm="4">
                                <b-input-group>
                                    <b-form-input
                                    v-model="template.supplier_name"
                                    type="text"
                                    class="form-control"
                                    :id="'template-' + template.id + '-' + template.supplier_name"
                                    readonly
                                    ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col sm="2">
                                <b-input-group>
                                    <b-form-input
                                    v-model="template.plate_size"
                                    type="text"
                                    class="form-control"
                                    :id="'template-' + template.id + '-' + template.plate_size"
                                    readonly
                                    ></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Target Destination for Template(s)</strong>
                    </div>                        
                    <CompanyAreaSiteSelection 
                        :company-id="filterParams.company_id" 
                        :area-id="filterParams.area_id"
                        :site-id="filterParams.site_id"
                        :user-auth-level="userAuthLevel"
                        v-on:company-selected="companySelected"
                        v-on:area-selected="areaSelected"
                        v-on:site-selected="siteSelected"
                    />
                    <b-row>
                        <b-col cols="12">
                            <p>
                                <b-button v-on:click="submitTargetDestination" variant="primary" :disabled="noTargetSelected">
                                    <i class="fa fa-check"></i>&nbsp;Submit
                                </b-button>
                            </p>
                            <b-alert v-if="noTargetSelected" variant="danger" show><strong>A Target Company, Area and Site must be selected</strong>
                            </b-alert>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { getCurrentUser } from '@/helpers/utils.js';

import CompanyAreaSiteSelection from '@/components/common/CompanyAreaSiteSelection.vue';
import Dashboard from '../../../views/Dashboard.vue';

export default {
    name: 'TemplateTargetSelection',
    props: ['current-selected'],
    emits: ['target-selected'],
    components: {
      CompanyAreaSiteSelection: CompanyAreaSiteSelection
    },
    data () {
      return {
        filterParams: {
            company_id: -1,
            area_id: -1,
            site_id: -1,
        },
        userAuthLevel : '',
        templateItems: []
      }
    },
    computed: {
        noTargetSelected() {
            let retValue = true;
            if (this.$data.filterParams.company_id < 1) {
                retValue = false;
            }
            if (this.$data.filterParams.area_id < 1) {
                retValue = false;
            }
            if (this.$data.filterParams.site_id < 1) {
                retValue = false;
            }
            return !retValue;
        }
    },
    created () {
        const userDetails = getCurrentUser();
        this.$data.filterParams.company_id = userDetails.company_id;
        this.$data.filterParams.area_id = userDetails.area_id;
        this.$data.filterParams.site_id = userDetails.site_id;
        this.$data.userAuthLevel = userDetails.auth;

        this.$data.templateItems = this.currentSelected.map((item) => {
            if (item.moveRequested) {
                item.action ='Move';
            }
            else {
                item.action = 'Copy';
            }
            return item;
        });
    },
    methods: {
        submitTargetDestination() {
            this.$emit('target-selected', this.$data.filterParams);
        },
        companySelected(value) {
            console.log('company selected: ', value);
            console.log('noTargetSelected: ', this.noTargetSelected);
            this.$data.filterParams.company_id = value;
        },
        areaSelected(value) {
            this.$data.filterParams.area_id = value;
        },
        siteSelected(value) {
            this.$data.filterParams.site_id = value;
        }
    }
}

</script>

<style scoped>
.row.output-row {
    padding-bottom: 8px;
}
div.selected-templates {
    margin-top: 8px;
}
</style>